import GetCryptoKey from './get-crypto-key';
const cryptoJs = require('crypto-js');

const cryptoKey = await GetCryptoKey();

export default function Encrypt(data) {
    if (data === undefined) {
        data = null;
    }

    return cryptoJs.AES.encrypt(JSON.stringify(data), cryptoKey).toString();
}
